import { useMemo } from 'react';

const defaultTabTitle: string = document.title;
export const useTabTitle = () => useMemo(() => ({
    setTabTitle: (section: string | undefined) => {
        document.title = section === undefined ? defaultTabTitle : `${ section } - ${ defaultTabTitle }`;
    },
}), []);